module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "dedication",
    attrs: {
      "id": "dedication_1"
    }
  }, [_c('p', {
    staticClass: "ded2"
  }, [_c('em', [_vm._v("For my parents, who nurtured my creativity, taught me the joy of hard work, and showed me every day of my childhood what true love is really all about.")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('em', [_vm._v("Miss you, Mom.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d310f93e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoControl_dedi_1.vue
// module id = 72
// module chunks = 0